class PastoreHeaderCharacters extends HTMLElement {
  connectedCallback() {
    this.controller = new AbortController();
    this.motion = (window.PastoreMotion || matchMedia('(prefers-reduced-motion: reduce)'));
    this.update = () => {
      this.frame = 0;
      const header = this.closest('.p-page-heading, .collection-hero');
      if (!header) return;
      const rect = header.getBoundingClientRect();
      const progress = this.motion.matches ? 0 : Math.max(0, Math.min(1, (window.scrollY) / (rect.height + 110)));
      this.style.setProperty('--character-scroll', progress.toFixed(4));
    };
    this.schedule = () => { if (!this.frame) this.frame = requestAnimationFrame(this.update); };
    const options = { passive: true, signal: this.controller.signal };
    addEventListener('scroll', this.schedule, options);
    addEventListener('resize', this.schedule, options);
    this.motion.addEventListener('change', this.schedule, { signal: this.controller.signal });
    this.update();
  }
  disconnectedCallback() { this.controller?.abort(); cancelAnimationFrame(this.frame); }
}
if (!customElements.get('pastore-header-characters')) customElements.define('pastore-header-characters', PastoreHeaderCharacters);
